<template>
  <div>
    <div class="dataPage">
      <div class="pageRank">
        <el-card class="half">
          <div class="halfTitle">{{$t('VehicleAnalysis.rank')}}</div>
          <div v-if="isValue" v-loading="StartStopOptionLoading">
            <linegraph
              :id="'bargraph1'"
              :data="StartStopOption"
              style="height: 300px"
            ></linegraph>
          </div>
          <div v-else class="halfNone">{{$t('common.noData')}}</div>
        </el-card>
      </div>
      <div class="pageRank" style="margin: 0 10px">
        <el-card class="half">
          <div class="halfTitle">{{$t('VehicleAnalysis.useTimeH')}}</div>
          <div v-if="isShow" v-loading="workOptionLoading">
            <linegraph
              :id="'bargraph2'"
              :data="workOption"
              style="height: 300px"
            ></linegraph>
          </div>
          <div v-else class="halfNone">{{$t('common.noData')}}</div>
        </el-card>
      </div>
      <div class="pageRank">
        <el-card class="half">
          <div class="halfTitle">{{$t('VehicleAnalysis.problemRank')}}</div>
          <div v-if="isDisplay" v-loading="faultOptionLoading">
            <linegraph
              :id="'bargraph3'"
              :data="faultOption"
              style="height: 300px"
            ></linegraph>
          </div>
          <div v-else class="halfNone">{{$t('common.noData')}}</div>
        </el-card>
      </div>
    </div>
    <div class="dataTable">
      <div class="rightAll-btn">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('common.num')">
            <el-select
              v-model="formInline.selectCarType"
              style="width: 120px"
              :placeholder="$t('common.choseTip')"
              class="selectStyle"
            >
              <el-option
                v-for="item in optionsInput"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-input
              size="mini"
              v-model="formInline.selectCarValue"
              :placeholder="$t('common.searchTip')"
              style="width: 150px"
              class="inputStyle"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              size="mini"
              type="primary"
              @click="onSearch"
              class="btn-chaxun"
              >{{$t('common.btn.search')}}</el-button
            >
            <el-button size="mini" @click="onClear" class="btn-del"
              >{{$t('common.btn.cancel')}}</el-button
            >
          </el-form-item>
        </el-form>
        <el-button v-if="isPrimaryKey('VEHICLEANALYSIS_COMPREHENSIVE_DAY_DOWN')" type="text" @click="downCar">{{$t('common.btn.download')}}</el-button>
      </div>
      <i-table
        :list="list"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import DayTime from "./DayTime";
export default DayTime;
</script>

<style lang="less" scoped>
@import "../../../../../assets/styles/Style.less";
</style>
